export interface KontrolAlertsSelectionInput {
    tenantId: number;
    partnerId: number;
    tenantName: string;
    partnerName: string;
}

/**
 * Whether the user may access Kontrol Alerts (Side Menu + /kontrol/alerts).
 *
 * Two complementary rules:
 * 1) TenantType CUSTOMER → never (no partner/global dropdown context for Alerts).
 * 2) PARTNER / GLOBAL_ADMIN → only in partner view (same as PartnerCustomerDropdown:
 *    first option “Partner Account” / tenant aligned with partner). If a customer is
 *    selected in the dropdown, deny.
 */
export function canAccessKontrolAlerts(
    tenantType: string,
    selection: KontrolAlertsSelectionInput
): boolean {
    if (tenantType === 'CUSTOMER') return false;
    if (tenantType !== 'PARTNER' && tenantType !== 'GLOBAL_ADMIN') return false;
    const isPartnerView =
        selection.tenantId === selection.partnerId ||
        selection.tenantName === selection.partnerName;
    return isPartnerView;
}
